// Accordion

const accSingleTriggers = document.querySelectorAll('.js-acc-single-trigger');

accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));

function toggleAccordion() {
  const items = document.querySelectorAll('.js-acc-item');
  const thisItem = this.parentNode;

  items.forEach(item => {
    if (thisItem == item) {
      thisItem.classList.toggle('is-open');
      return;
    }
    item.classList.remove('is-open');
  });
}

  
  // card product grid in collection
  
document.addEventListener("DOMContentLoaded", function() {
    var swiper = new Swiper(".collection-card-slider", {
        navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
});


//   $(window).scroll(function() {    
//     var scroll = $(window).scrollTop();
//     if (scroll >= 50) {
//         $(".header").addClass("active-header");
//     }else {
//         $("header").removeClass("active-header");
//     }
// });

// document.addEventListener("DOMContentLoaded", function() {
//     var swiper = new Swiper(".collection-card-slider", {
//         navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//       }, 
//       pagination: {
//         el: ".swiper-pagination",
//         clickable: true
//       },
//       breakpoints: {
//         200: {
//           slidesPerView: 1,
//           spaceBetween: 1,
//         },
//         1200: {
//           slidesPerView: 4,
//           spaceBetween: 1,
//           loop: false,
// 	        slidesPerGroup: 4
//         }
//       }
//     });
// });

// **********MENU HOVER Code**************** //
let items=document.querySelector(".header__inline-menu").querySelectorAll("details");
var header = document.querySelector(".header");
items.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    header.classList.add("header-bg");
    item.querySelector("div").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      header.classList.remove("header-bg");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      header.classList.remove("header-bg");
    });
  });
});

/*Add To Bag Loader*/

// $('.product-form__submit').click(function() {
// $('.product-form__submit').text('Added to Bag');
//    setTimeout( function(){
// $('.product-form__submit').text('Add to Bag');
// }, 1000);
// });
